import { print } from 'graphql';
import gql from 'graphql-tag';
import type { RxCollection, RxDocument, RxJsonSchema } from 'rxdb';

import { BaseEntity } from '../../models/BaseEntity';
import { generatePullQuery, PullQueryContext } from '../queryBuilders/generatePullQuery';
import { defaultDocAllTime } from '../Shared/defaultDoc';

export interface ServiceStatus extends BaseEntity {
  description: string;
}
export type ServiceStatusCollection = RxCollection<ServiceStatus> | null;
export type ServiceStatusDocument = RxDocument<ServiceStatus>;

export const serviceStatusSchema: RxJsonSchema<ServiceStatus> = {
  type: 'object',
  version: 0,
  description: 'describes a serviceStatus object',
  primaryKey: 'id',
  properties: {
    id: { type: 'string', maxLength: 36 },
    updatedAt: { type: 'number' },
    isDeleted: { type: 'boolean' },
    version: { type: 'number' },
    description: { type: 'string' },
  },
};

const serviceStatusFeedQuery = print(gql`
  query serviceStatusFeed($siteId: ID!, $lastUpdateAt: Float!, $limit: Int!) {
    serviceStatusFeed(siteId: $siteId, lastUpdateAt: $lastUpdateAt, limit: $limit) {
      description
      id
      isDeleted
      updatedAt
      version
    }
  }
`);

export const serviceStatusPullQueryBuilder = generatePullQuery(
  serviceStatusFeedQuery,
  PullQueryContext.Site,
  defaultDocAllTime,
);

export default {};
